import { ExchangeSwift, ExchangeSwiftScanResult } from "../models/ExchangeSwift";
import api from "./api";

export const getExchangeSwifts = async (): Promise<ExchangeSwift[]> => {
  const response = await api.get("api/exchange-swifts");
  return response.data;
};

export const setExchangeSwiftSent = async (id: string, sent: boolean) => {
  const response = await api.put(`api/exchange-swifts/${id}/sent`, { sent });
  return response.data as { success: boolean; notifications: string[] };
};

export const scanExchangeSwifts = async (): Promise<ExchangeSwiftScanResult> => {
  const response = await api.post("api/exchange-swifts/scan");
  return response.data;
};
